import type { EntityConfig } from '../types'

export const mmReserveEntity: EntityConfig = {
  name: 'mm-reserve',
  label: 'Reserve',
  pluralLabel: 'Reserves',
  status: {
    field: 'status',
    options: [
      { value: 'active', label: 'Active', variant: 'success' },
      { value: 'released', label: 'Released', variant: 'secondary' },
      { value: 'pending', label: 'Pending', variant: 'warning' },
      { value: 'expired', label: 'Expired', variant: 'secondary' },
    ],
    filters: [
      { value: 'all', label: 'All' },
      { value: 'active', label: 'Active' },
      { value: 'released', label: 'Released' },
      { value: 'pending', label: 'Pending' },
      { value: 'expired', label: 'Expired' },
    ],
    mappings: {
      all: ['active', 'released', 'pending', 'expired'],
      active: ['active'],
      released: ['released'],
      pending: ['pending'],
      expired: ['expired'],
    }
  },
  queryFields: {
    merchantName: { field: 'merchantName', type: 'text' },
    type: { field: 'type', type: 'text' },
    currency: { field: 'currency', type: 'text' },
  },
  uiFilterFields: ['status', 'type', 'currency'],
}
